import { IQusteion, QuestionType } from 'src/utils/Interfaces/survey.interface'
import style from './style.module.scss'
import { useEffect, useState } from 'react'
import Input from 'src/Components/Form/Input'
import Select from 'src/Components/Form/Select'
import TextSvg from 'src/assets/img/icons/text.svg'
import SingleSvg from 'src/assets/img/icons/single.svg'
import MultipleSvg from 'src/assets/img/icons/multiple.svg'
import DragIndicatorOutlinedIcon from '@mui/icons-material/DragIndicatorOutlined'
import EditIcon from 'src/Components/Icons/EditIcon'
import DeleteIcon from 'src/Components/Icons/DeleteIcon'
import PlusIcon from 'src/Components/Icons/PlusIcon'
import MinusIcon from 'src/Components/Icons/MinusIcon'
import MsgIcon from 'src/Components/Icons/MsgIcon'
import { Reorder } from 'framer-motion'

interface Props {
  question: IQusteion
  defaultForm?: boolean
  saveQuestion: (question: IQusteion) => void
  deleteQuestion: () => void
  index: number
}

const QuestionItem = ({ question, defaultForm, saveQuestion, deleteQuestion, index }: Props) => {
  const [questionForm, setQuestionForm] = useState(defaultForm || false)
  const [newQuestion, setNewQuestion] = useState(question)

  useEffect(() => {
    setNewQuestion(question)
  }, [question])
  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setNewQuestion({ ...newQuestion, questionText: e.target.value })
  }

  const handleTypeChange = (e: QuestionType) => {
    setNewQuestion((prevQuestion) => ({
      ...prevQuestion,
      type: e,
      answers:
        prevQuestion.answers.length === 0 && (e === 'MULTIPLE' || e === 'SINGLE')
          ? [
              { text: 'Answer 1', nextQ: index + 1, ownAnswer: false },
              { text: 'Answer 2', nextQ: index + 1, ownAnswer: false }
            ]
          : e === 'TEXT'
            ? []
            : prevQuestion.answers
    }))
  }

  const handleAddAnswer = () => {
    setNewQuestion((prevQuestion) => ({
      ...prevQuestion,
      answers: [
        ...prevQuestion.answers,
        {
          text: `Answer ${prevQuestion.answers.length + 1}`,
          nextQ: index + 1
        }
      ]
    }))
  }

  const handleSave = () => {
    setQuestionForm(false)
    saveQuestion(newQuestion)
  }

  const handleAnswerChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const newAnswers = newQuestion.answers.map((item, i) => (i === index ? { ...item, text: e.target.value } : item))
    setNewQuestion({ ...newQuestion, answers: newAnswers })
  }

  const handleNextQChange = (e: React.ChangeEvent<HTMLInputElement>, index: number) => {
    const newAnswers = newQuestion.answers.map((item, i) => (i === index ? { ...item, nextQ: +e.target.value } : item))
    setNewQuestion({ ...newQuestion, answers: newAnswers })
  }

  const handleOwnAnswerChange = (index: number) => {
    const newAnswers = newQuestion.answers.map((item, i) =>
      i === index ? { ...item, ownAnswer: !item.ownAnswer } : item
    )
    setNewQuestion({ ...newQuestion, answers: newAnswers })
  }

  return (
    <li className={style.question} data-type={question.type}>
      <div className={style.main}>
        {newQuestion.type === 'TEXT' && <img src={TextSvg} alt="text" />}
        {newQuestion.type === 'SINGLE' && <img src={SingleSvg} alt="single" />}
        {newQuestion.type === 'MULTIPLE' && <img src={MultipleSvg} alt="multiple" />}
        <p>{newQuestion.questionText}</p>
        <div className={style.actions}>
          {questionForm ? (
            <button className="btn" onClick={handleSave}>
              Save
            </button>
          ) : (
            <span onClick={() => setQuestionForm(true)}>
              <EditIcon />
            </span>
          )}
          <span onClick={() => deleteQuestion()}>
            <DeleteIcon />
          </span>
        </div>
      </div>
      {questionForm && (
        <div className={style.question_form}>
          <div>
            <Select<QuestionType>
              className="light "
              list={['TEXT', 'MULTIPLE', 'SINGLE']}
              label="Type"
              value={newQuestion.type}
              onChange={handleTypeChange}
            />
            <Input
              className="light"
              name="QText"
              label="Question"
              value={newQuestion.questionText}
              onChange={handleTextChange}
            />
          </div>
          <div className={style.add_answer}>
            <p>Answers</p>
            <span onClick={handleAddAnswer}>
              <PlusIcon />
            </span>
          </div>
          <Reorder.Group
            values={newQuestion.answers}
            onReorder={(reordered) => setNewQuestion({ ...newQuestion, answers: reordered })}
          >
            {newQuestion.answers.map((item, i) => (
              <Reorder.Item
                value={item}
                key={item.text}
                // draggable
                // onDragStart={() => handleStartDrag(i)}
                // onDragEnter={() => handleDragEnter(i)}
                // onDragEnd={() => handleDragend()}
              >
                <DragIndicatorOutlinedIcon />
                <div className={style.answer_wrap}>
                  <Input
                    name="Answer"
                    label={`Answer ${i + 1}`}
                    value={item.text}
                    onChange={(e) => handleAnswerChange(e, i)}
                    className="light"
                  />
                  <span
                    onClick={() => handleOwnAnswerChange(i)}
                    data-active={item.ownAnswer}
                    className={style.ownAnswer}
                  >
                    <MsgIcon />
                  </span>
                </div>
                <Input
                  className="light"
                  type="number"
                  min="0"
                  name="NextQ"
                  label="Next"
                  value={item.nextQ.toString()}
                  onChange={(e) => handleNextQChange(e, i)}
                />
                <span
                  onClick={() =>
                    setNewQuestion((prevQuestion) => ({
                      ...prevQuestion,
                      answers: prevQuestion.answers.filter((_, index) => index !== i)
                    }))
                  }
                >
                  <MinusIcon />
                </span>
              </Reorder.Item>
            ))}
          </Reorder.Group>
        </div>
      )}
    </li>
  )
}

export default QuestionItem
